import React, { FC } from 'react'
import { MtsDengiButton } from '@mtsdengi/ui-kit'
import { SmartVisibleChild } from '@mtsdengi/common'
import { useHiddenLayer } from '@shared/utils'
import { TMobileFloatingButtonProps } from './types'
import { Styled } from './styled'

const MOBILE_VISIBLE_CONDITIONS = { none: 'block', tablet: 'none' }

export const MobileFloatingButton: FC<TMobileFloatingButtonProps> = ({
  buttonProps,
  onButtonClick,
  bottomValue,
  hiddenIds,
  delayBeforeAction,
}) => {
  const isHidden = useHiddenLayer(hiddenIds, delayBeforeAction)

  return (
    <SmartVisibleChild conditions={MOBILE_VISIBLE_CONDITIONS}>
      <Styled.Wrapper isHidden={isHidden} bottomValue={bottomValue}>
        <MtsDengiButton onClick={onButtonClick} {...buttonProps}>
          {buttonProps.text}
        </MtsDengiButton>
      </Styled.Wrapper>
    </SmartVisibleChild>
  )
}
